module.exports = __webpack_public_path__ + "img/bg-rent.0c0b3395.jpeg";